import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzCardComponent } from 'ng-zorro-antd/card';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { NzSpinComponent } from 'ng-zorro-antd/spin';
import { NzInputDirective, NzInputGroupComponent } from 'ng-zorro-antd/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzOptionComponent, NzSelectComponent } from 'ng-zorro-antd/select';
import {
  NzFormControlComponent,
  NzFormDirective,
  NzFormLabelComponent,
} from 'ng-zorro-antd/form';
import { NzDividerComponent } from 'ng-zorro-antd/divider';
import {
  NzDatePickerComponent,
  NzDatePickerModule,
  NzRangePickerComponent,
} from 'ng-zorro-antd/date-picker';
import { NzTypographyComponent } from 'ng-zorro-antd/typography';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzIconDirective } from 'ng-zorro-antd/icon';
import { RouterModule } from '@angular/router';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { ManageMasterDataConfigComponent } from './manage-master-data-config/manage-master-data-config.component';
import { ManageMasterDataComponent } from './manage-master-data/manage-master-data.component';
import { SearchMasterDataComponent } from './search-master-data/search-master-data.component';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';

@NgModule({
  declarations: [
    ManageMasterDataConfigComponent,
    ManageMasterDataComponent,
    SearchMasterDataComponent
  ],
  imports: [
    NzListModule,
    NzSkeletonModule,
    NzListModule,
    NzToolTipModule,
    RouterModule,
    CommonModule,
    NzCardComponent,
    NzRowDirective,
    NzSpinComponent,
    NzInputDirective,
    FormsModule,
    NzColDirective,
    NzOptionComponent,
    NzSelectComponent,
    NzFormDirective,
    ReactiveFormsModule,
    NzFormLabelComponent,
    NzDividerComponent,
    NzInputGroupComponent,
    NzDatePickerComponent,
    NzTypographyComponent,
    NzButtonComponent,
    NzIconDirective,
    NzFormControlComponent,
    NzTableModule,
    NzTabsModule,
    NzCheckboxModule,
    NzDropDownModule,
    NzDatePickerModule,
    NzRangePickerComponent,
    NzTagModule,
    NzSwitchModule,
    NzUploadModule,
    NzDrawerModule,
    NzRadioModule,
    NzModalModule,
    RouterModule,
    NzDescriptionsModule
  ],
})
export class MasterDataModule { }
